"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _react = _interopRequireDefault(require("react"));

var _classnames = _interopRequireDefault(require("classnames"));

var _get2 = _interopRequireDefault(require("lodash/get"));

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty2["default"])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

var texts = {
  sm: '',
  md: 'text-xl'
};
var icons = {
  sm: {
    className: 'px-6',
    style: {
      width: 70
    }
  },
  md: {
    className: 'pr-5',
    style: {
      width: 100
    }
  }
};

var View = function View(_ref) {
  var icon = _ref.icon,
      _ref$size = _ref.size,
      size = _ref$size === void 0 ? 'md' : _ref$size,
      children = _ref.children,
      valign = _ref.valign;
  var textClasses = (0, _get2["default"])(texts, size, texts.md);

  var _get = (0, _get2["default"])(icons, size, icons.md),
      iconClassName = _get.className,
      iconStyle = _get.style;

  return /*#__PURE__*/_react["default"].createElement("div", {
    className: (0, _classnames["default"])('flex py-3', valign === 'top' ? 'items-start' : 'items-center')
  }, !!icon && /*#__PURE__*/_react["default"].createElement("div", {
    style: _objectSpread(_objectSpread({}, iconStyle), {}, {
      paddingTop: valign === 'top' ? 2 : 'unset'
    }),
    className: (0, _classnames["default"])('text-gray-light flex items-start justify-center', iconClassName)
  }, icon), /*#__PURE__*/_react["default"].createElement("div", {
    className: (0, _classnames["default"])('flex-1 text-dark pr-2 min-w-0', textClasses)
  }, children));
};

View.displayName = 'Item';
var _default = View;
exports["default"] = _default;
//# sourceMappingURL=Item.js.map